/**
 * Soccer :: Perform :: API 1.0.0
 *
 * Contact: support@nativewaves.com
 *
 * DO NOT EDIT THIS CLASS MANUALLY!
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class FixturesApi extends runtime.BaseAPI {
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-commentary.htm\">Perform Documentation - MA6</a>
     * Returns the MA6 feed
     */
    async performSoccerdataFixturesFixtureIdCommentaryGetRaw(requestParameters, initOverrides) {
        if (requestParameters.fixtureId === null ||
            requestParameters.fixtureId === undefined) {
            throw new runtime.RequiredError('fixtureId', 'Required parameter requestParameters.fixtureId was null or undefined when calling performSoccerdataFixturesFixtureIdCommentaryGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/fixtures/{fixtureId}/commentary`.replace(`{${'fixtureId'}}`, String(requestParameters.fixtureId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-commentary.htm\">Perform Documentation - MA6</a>
     * Returns the MA6 feed
     */
    async performSoccerdataFixturesFixtureIdCommentaryGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataFixturesFixtureIdCommentaryGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-commentary.htm\">Perform Documentation - MA6</a>
     * Returns a snapshot of the MA6 feed
     */
    async performSoccerdataFixturesFixtureIdCommentarySnapshotsSnapshotIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.fixtureId === null ||
            requestParameters.fixtureId === undefined) {
            throw new runtime.RequiredError('fixtureId', 'Required parameter requestParameters.fixtureId was null or undefined when calling performSoccerdataFixturesFixtureIdCommentarySnapshotsSnapshotIdGet.');
        }
        if (requestParameters.snapshotId === null ||
            requestParameters.snapshotId === undefined) {
            throw new runtime.RequiredError('snapshotId', 'Required parameter requestParameters.snapshotId was null or undefined when calling performSoccerdataFixturesFixtureIdCommentarySnapshotsSnapshotIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/fixtures/{fixtureId}/commentary/snapshots/{snapshotId}`
                .replace(`{${'fixtureId'}}`, String(requestParameters.fixtureId))
                .replace(`{${'snapshotId'}}`, String(requestParameters.snapshotId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-commentary.htm\">Perform Documentation - MA6</a>
     * Returns a snapshot of the MA6 feed
     */
    async performSoccerdataFixturesFixtureIdCommentarySnapshotsSnapshotIdGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataFixturesFixtureIdCommentarySnapshotsSnapshotIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-fixtures-and-results.htm\">Perform Documentation - MA1</a>
     * Returns the MA1 feed
     */
    async performSoccerdataFixturesFixtureIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.fixtureId === null ||
            requestParameters.fixtureId === undefined) {
            throw new runtime.RequiredError('fixtureId', 'Required parameter requestParameters.fixtureId was null or undefined when calling performSoccerdataFixturesFixtureIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/fixtures/{fixtureId}`.replace(`{${'fixtureId'}}`, String(requestParameters.fixtureId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-fixtures-and-results.htm\">Perform Documentation - MA1</a>
     * Returns the MA1 feed
     */
    async performSoccerdataFixturesFixtureIdGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataFixturesFixtureIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-match-events.htm\">Perform Documentation - MA3</a>
     * Returns the MA3 feed
     */
    async performSoccerdataFixturesFixtureIdMatcheventGetRaw(requestParameters, initOverrides) {
        if (requestParameters.fixtureId === null ||
            requestParameters.fixtureId === undefined) {
            throw new runtime.RequiredError('fixtureId', 'Required parameter requestParameters.fixtureId was null or undefined when calling performSoccerdataFixturesFixtureIdMatcheventGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/fixtures/{fixtureId}/matchevent`.replace(`{${'fixtureId'}}`, String(requestParameters.fixtureId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-match-events.htm\">Perform Documentation - MA3</a>
     * Returns the MA3 feed
     */
    async performSoccerdataFixturesFixtureIdMatcheventGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataFixturesFixtureIdMatcheventGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-match-events.htm\">Perform Documentation - MA3</a>
     * Returns a snapshot of the MA3 feed
     */
    async performSoccerdataFixturesFixtureIdMatcheventSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.fixtureId === null ||
            requestParameters.fixtureId === undefined) {
            throw new runtime.RequiredError('fixtureId', 'Required parameter requestParameters.fixtureId was null or undefined when calling performSoccerdataFixturesFixtureIdMatcheventSnapshotsSnapshotIdGet.');
        }
        if (requestParameters.snapshotId === null ||
            requestParameters.snapshotId === undefined) {
            throw new runtime.RequiredError('snapshotId', 'Required parameter requestParameters.snapshotId was null or undefined when calling performSoccerdataFixturesFixtureIdMatcheventSnapshotsSnapshotIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/fixtures/{fixtureId}/matchevent/snapshots/{snapshotId}`
                .replace(`{${'fixtureId'}}`, String(requestParameters.fixtureId))
                .replace(`{${'snapshotId'}}`, String(requestParameters.snapshotId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-match-events.htm\">Perform Documentation - MA3</a>
     * Returns a snapshot of the MA3 feed
     */
    async performSoccerdataFixturesFixtureIdMatcheventSnapshotsSnapshotIdGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataFixturesFixtureIdMatcheventSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-match-expected-goals.htm\">Perform Documentation - MA12</a>
     * Returns the MA12 feed
     */
    async performSoccerdataFixturesFixtureIdMatchexpectedgoalsGetRaw(requestParameters, initOverrides) {
        if (requestParameters.fixtureId === null ||
            requestParameters.fixtureId === undefined) {
            throw new runtime.RequiredError('fixtureId', 'Required parameter requestParameters.fixtureId was null or undefined when calling performSoccerdataFixturesFixtureIdMatchexpectedgoalsGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/fixtures/{fixtureId}/matchexpectedgoals`.replace(`{${'fixtureId'}}`, String(requestParameters.fixtureId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-match-expected-goals.htm\">Perform Documentation - MA12</a>
     * Returns the MA12 feed
     */
    async performSoccerdataFixturesFixtureIdMatchexpectedgoalsGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataFixturesFixtureIdMatchexpectedgoalsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-match-expected-goals.htm\">Perform Documentation - MA12</a>
     * Returns a snapshot of the MA12 feed
     */
    async performSoccerdataFixturesFixtureIdMatchexpectedgoalsSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.fixtureId === null ||
            requestParameters.fixtureId === undefined) {
            throw new runtime.RequiredError('fixtureId', 'Required parameter requestParameters.fixtureId was null or undefined when calling performSoccerdataFixturesFixtureIdMatchexpectedgoalsSnapshotsSnapshotIdGet.');
        }
        if (requestParameters.snapshotId === null ||
            requestParameters.snapshotId === undefined) {
            throw new runtime.RequiredError('snapshotId', 'Required parameter requestParameters.snapshotId was null or undefined when calling performSoccerdataFixturesFixtureIdMatchexpectedgoalsSnapshotsSnapshotIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/fixtures/{fixtureId}/matchexpectedgoals/snapshots/{snapshotId}`
                .replace(`{${'fixtureId'}}`, String(requestParameters.fixtureId))
                .replace(`{${'snapshotId'}}`, String(requestParameters.snapshotId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-match-expected-goals.htm\">Perform Documentation - MA12</a>
     * Returns a snapshot of the MA12 feed
     */
    async performSoccerdataFixturesFixtureIdMatchexpectedgoalsSnapshotsSnapshotIdGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataFixturesFixtureIdMatchexpectedgoalsSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-match-facts.htm\">Perform Documentation - MA9</a>
     * Returns the MA9 feed
     */
    async performSoccerdataFixturesFixtureIdMatchfactsGetRaw(requestParameters, initOverrides) {
        if (requestParameters.fixtureId === null ||
            requestParameters.fixtureId === undefined) {
            throw new runtime.RequiredError('fixtureId', 'Required parameter requestParameters.fixtureId was null or undefined when calling performSoccerdataFixturesFixtureIdMatchfactsGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/fixtures/{fixtureId}/matchfacts`.replace(`{${'fixtureId'}}`, String(requestParameters.fixtureId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-match-facts.htm\">Perform Documentation - MA9</a>
     * Returns the MA9 feed
     */
    async performSoccerdataFixturesFixtureIdMatchfactsGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataFixturesFixtureIdMatchfactsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-match-facts.htm\">Perform Documentation - MA9</a>
     * Returns a snapshot of the MA9 feed
     */
    async performSoccerdataFixturesFixtureIdMatchfactsSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.fixtureId === null ||
            requestParameters.fixtureId === undefined) {
            throw new runtime.RequiredError('fixtureId', 'Required parameter requestParameters.fixtureId was null or undefined when calling performSoccerdataFixturesFixtureIdMatchfactsSnapshotsSnapshotIdGet.');
        }
        if (requestParameters.snapshotId === null ||
            requestParameters.snapshotId === undefined) {
            throw new runtime.RequiredError('snapshotId', 'Required parameter requestParameters.snapshotId was null or undefined when calling performSoccerdataFixturesFixtureIdMatchfactsSnapshotsSnapshotIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/fixtures/{fixtureId}/matchfacts/snapshots/{snapshotId}`
                .replace(`{${'fixtureId'}}`, String(requestParameters.fixtureId))
                .replace(`{${'snapshotId'}}`, String(requestParameters.snapshotId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-match-facts.htm\">Perform Documentation - MA9</a>
     * Returns a snapshot of the MA9 feed
     */
    async performSoccerdataFixturesFixtureIdMatchfactsSnapshotsSnapshotIdGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataFixturesFixtureIdMatchfactsSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-match-facts-all.htm\">Perform Documentation - MA16</a>
     * Returns the MA16 feed
     */
    async performSoccerdataFixturesFixtureIdMatchfactsallGetRaw(requestParameters, initOverrides) {
        if (requestParameters.fixtureId === null ||
            requestParameters.fixtureId === undefined) {
            throw new runtime.RequiredError('fixtureId', 'Required parameter requestParameters.fixtureId was null or undefined when calling performSoccerdataFixturesFixtureIdMatchfactsallGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/fixtures/{fixtureId}/matchfactsall`.replace(`{${'fixtureId'}}`, String(requestParameters.fixtureId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-match-facts-all.htm\">Perform Documentation - MA16</a>
     * Returns the MA16 feed
     */
    async performSoccerdataFixturesFixtureIdMatchfactsallGet(requestParameters, initOverrides) {
        await this.performSoccerdataFixturesFixtureIdMatchfactsallGetRaw(requestParameters, initOverrides);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-match-fitness.htm\">Perform Documentation - MA24</a>
     * Returns the MA24 feed
     */
    async performSoccerdataFixturesFixtureIdMatchfitnessGetRaw(requestParameters, initOverrides) {
        if (requestParameters.fixtureId === null ||
            requestParameters.fixtureId === undefined) {
            throw new runtime.RequiredError('fixtureId', 'Required parameter requestParameters.fixtureId was null or undefined when calling performSoccerdataFixturesFixtureIdMatchfitnessGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/fixtures/{fixtureId}/matchfitness`.replace(`{${'fixtureId'}}`, String(requestParameters.fixtureId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-match-fitness.htm\">Perform Documentation - MA24</a>
     * Returns the MA24 feed
     */
    async performSoccerdataFixturesFixtureIdMatchfitnessGet(requestParameters, initOverrides) {
        await this.performSoccerdataFixturesFixtureIdMatchfitnessGetRaw(requestParameters, initOverrides);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-live-win-probability.htm\">Perform Documentation - MA21</a>
     * Returns the MA21 feed
     */
    async performSoccerdataFixturesFixtureIdMatchlivewinprobabilityGetRaw(requestParameters, initOverrides) {
        if (requestParameters.fixtureId === null ||
            requestParameters.fixtureId === undefined) {
            throw new runtime.RequiredError('fixtureId', 'Required parameter requestParameters.fixtureId was null or undefined when calling performSoccerdataFixturesFixtureIdMatchlivewinprobabilityGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/fixtures/{fixtureId}/matchlivewinprobability`.replace(`{${'fixtureId'}}`, String(requestParameters.fixtureId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-live-win-probability.htm\">Perform Documentation - MA21</a>
     * Returns the MA21 feed
     */
    async performSoccerdataFixturesFixtureIdMatchlivewinprobabilityGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataFixturesFixtureIdMatchlivewinprobabilityGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-live-win-probability.htm\">Perform Documentation - MA21</a>
     * Returns a snapshot of the MA21 feed
     */
    async performSoccerdataFixturesFixtureIdMatchlivewinprobabilitySnapshotsSnapshotIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.fixtureId === null ||
            requestParameters.fixtureId === undefined) {
            throw new runtime.RequiredError('fixtureId', 'Required parameter requestParameters.fixtureId was null or undefined when calling performSoccerdataFixturesFixtureIdMatchlivewinprobabilitySnapshotsSnapshotIdGet.');
        }
        if (requestParameters.snapshotId === null ||
            requestParameters.snapshotId === undefined) {
            throw new runtime.RequiredError('snapshotId', 'Required parameter requestParameters.snapshotId was null or undefined when calling performSoccerdataFixturesFixtureIdMatchlivewinprobabilitySnapshotsSnapshotIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/fixtures/{fixtureId}/matchlivewinprobability/snapshots/{snapshotId}`
                .replace(`{${'fixtureId'}}`, String(requestParameters.fixtureId))
                .replace(`{${'snapshotId'}}`, String(requestParameters.snapshotId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-live-win-probability.htm\">Perform Documentation - MA21</a>
     * Returns a snapshot of the MA21 feed
     */
    async performSoccerdataFixturesFixtureIdMatchlivewinprobabilitySnapshotsSnapshotIdGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataFixturesFixtureIdMatchlivewinprobabilitySnapshotsSnapshotIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-match-penalties-preview.htm\">Perform Documentation - MA19</a>
     * Returns the MA19 feed
     */
    async performSoccerdataFixturesFixtureIdMatchpenaltiespreviewGetRaw(requestParameters, initOverrides) {
        if (requestParameters.fixtureId === null ||
            requestParameters.fixtureId === undefined) {
            throw new runtime.RequiredError('fixtureId', 'Required parameter requestParameters.fixtureId was null or undefined when calling performSoccerdataFixturesFixtureIdMatchpenaltiespreviewGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/fixtures/{fixtureId}/matchpenaltiespreview`.replace(`{${'fixtureId'}}`, String(requestParameters.fixtureId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-match-penalties-preview.htm\">Perform Documentation - MA19</a>
     * Returns the MA19 feed
     */
    async performSoccerdataFixturesFixtureIdMatchpenaltiespreviewGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataFixturesFixtureIdMatchpenaltiespreviewGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-match-penalties-preview.htm\">Perform Documentation - MA19</a>
     * Returns a snapshot of the MA19 feed
     */
    async performSoccerdataFixturesFixtureIdMatchpenaltiespreviewSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.fixtureId === null ||
            requestParameters.fixtureId === undefined) {
            throw new runtime.RequiredError('fixtureId', 'Required parameter requestParameters.fixtureId was null or undefined when calling performSoccerdataFixturesFixtureIdMatchpenaltiespreviewSnapshotsSnapshotIdGet.');
        }
        if (requestParameters.snapshotId === null ||
            requestParameters.snapshotId === undefined) {
            throw new runtime.RequiredError('snapshotId', 'Required parameter requestParameters.snapshotId was null or undefined when calling performSoccerdataFixturesFixtureIdMatchpenaltiespreviewSnapshotsSnapshotIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/fixtures/{fixtureId}/matchpenaltiespreview/snapshots/{snapshotId}`
                .replace(`{${'fixtureId'}}`, String(requestParameters.fixtureId))
                .replace(`{${'snapshotId'}}`, String(requestParameters.snapshotId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-match-penalties-preview.htm\">Perform Documentation - MA19</a>
     * Returns a snapshot of the MA19 feed
     */
    async performSoccerdataFixturesFixtureIdMatchpenaltiespreviewSnapshotsSnapshotIdGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataFixturesFixtureIdMatchpenaltiespreviewSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-match-player-ratings.htm\">Perform Documentation - MA20</a>
     * Returns the MA20 feed
     */
    async performSoccerdataFixturesFixtureIdMatchplayerratingsGetRaw(requestParameters, initOverrides) {
        if (requestParameters.fixtureId === null ||
            requestParameters.fixtureId === undefined) {
            throw new runtime.RequiredError('fixtureId', 'Required parameter requestParameters.fixtureId was null or undefined when calling performSoccerdataFixturesFixtureIdMatchplayerratingsGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/fixtures/{fixtureId}/matchplayerratings`.replace(`{${'fixtureId'}}`, String(requestParameters.fixtureId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-match-player-ratings.htm\">Perform Documentation - MA20</a>
     * Returns the MA20 feed
     */
    async performSoccerdataFixturesFixtureIdMatchplayerratingsGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataFixturesFixtureIdMatchplayerratingsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-match-player-ratings.htm\">Perform Documentation - MA20</a>
     * Returns a snapshot of the MA20 feed
     */
    async performSoccerdataFixturesFixtureIdMatchplayerratingsSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.fixtureId === null ||
            requestParameters.fixtureId === undefined) {
            throw new runtime.RequiredError('fixtureId', 'Required parameter requestParameters.fixtureId was null or undefined when calling performSoccerdataFixturesFixtureIdMatchplayerratingsSnapshotsSnapshotIdGet.');
        }
        if (requestParameters.snapshotId === null ||
            requestParameters.snapshotId === undefined) {
            throw new runtime.RequiredError('snapshotId', 'Required parameter requestParameters.snapshotId was null or undefined when calling performSoccerdataFixturesFixtureIdMatchplayerratingsSnapshotsSnapshotIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/fixtures/{fixtureId}/matchplayerratings/snapshots/{snapshotId}`
                .replace(`{${'fixtureId'}}`, String(requestParameters.fixtureId))
                .replace(`{${'snapshotId'}}`, String(requestParameters.snapshotId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-match-player-ratings.htm\">Perform Documentation - MA20</a>
     * Returns a snapshot of the MA20 feed
     */
    async performSoccerdataFixturesFixtureIdMatchplayerratingsSnapshotsSnapshotIdGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataFixturesFixtureIdMatchplayerratingsSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-match-preview.htm\">Perform Documentation - MA8</a>
     * Returns the MA8 feed
     */
    async performSoccerdataFixturesFixtureIdMatchpreviewGetRaw(requestParameters, initOverrides) {
        if (requestParameters.fixtureId === null ||
            requestParameters.fixtureId === undefined) {
            throw new runtime.RequiredError('fixtureId', 'Required parameter requestParameters.fixtureId was null or undefined when calling performSoccerdataFixturesFixtureIdMatchpreviewGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/fixtures/{fixtureId}/matchpreview`.replace(`{${'fixtureId'}}`, String(requestParameters.fixtureId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-match-preview.htm\">Perform Documentation - MA8</a>
     * Returns the MA8 feed
     */
    async performSoccerdataFixturesFixtureIdMatchpreviewGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataFixturesFixtureIdMatchpreviewGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-match-preview.htm\">Perform Documentation - MA8</a>
     * Returns a snapshot of the MA8 feed
     */
    async performSoccerdataFixturesFixtureIdMatchpreviewSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.fixtureId === null ||
            requestParameters.fixtureId === undefined) {
            throw new runtime.RequiredError('fixtureId', 'Required parameter requestParameters.fixtureId was null or undefined when calling performSoccerdataFixturesFixtureIdMatchpreviewSnapshotsSnapshotIdGet.');
        }
        if (requestParameters.snapshotId === null ||
            requestParameters.snapshotId === undefined) {
            throw new runtime.RequiredError('snapshotId', 'Required parameter requestParameters.snapshotId was null or undefined when calling performSoccerdataFixturesFixtureIdMatchpreviewSnapshotsSnapshotIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/fixtures/{fixtureId}/matchpreview/snapshots/{snapshotId}`
                .replace(`{${'fixtureId'}}`, String(requestParameters.fixtureId))
                .replace(`{${'snapshotId'}}`, String(requestParameters.snapshotId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-match-preview.htm\">Perform Documentation - MA8</a>
     * Returns a snapshot of the MA8 feed
     */
    async performSoccerdataFixturesFixtureIdMatchpreviewSnapshotsSnapshotIdGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataFixturesFixtureIdMatchpreviewSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-match-statistics.htm\">Perform Documentation - MA2</a>
     * Returns the MA2 feed
     */
    async performSoccerdataFixturesFixtureIdMatchstatsGetRaw(requestParameters, initOverrides) {
        if (requestParameters.fixtureId === null ||
            requestParameters.fixtureId === undefined) {
            throw new runtime.RequiredError('fixtureId', 'Required parameter requestParameters.fixtureId was null or undefined when calling performSoccerdataFixturesFixtureIdMatchstatsGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/fixtures/{fixtureId}/matchstats`.replace(`{${'fixtureId'}}`, String(requestParameters.fixtureId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-match-statistics.htm\">Perform Documentation - MA2</a>
     * Returns the MA2 feed
     */
    async performSoccerdataFixturesFixtureIdMatchstatsGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataFixturesFixtureIdMatchstatsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-match-statistics.htm\">Perform Documentation - MA2</a>
     * Returns a snapshot of the MA2 feed
     */
    async performSoccerdataFixturesFixtureIdMatchstatsSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.fixtureId === null ||
            requestParameters.fixtureId === undefined) {
            throw new runtime.RequiredError('fixtureId', 'Required parameter requestParameters.fixtureId was null or undefined when calling performSoccerdataFixturesFixtureIdMatchstatsSnapshotsSnapshotIdGet.');
        }
        if (requestParameters.snapshotId === null ||
            requestParameters.snapshotId === undefined) {
            throw new runtime.RequiredError('snapshotId', 'Required parameter requestParameters.snapshotId was null or undefined when calling performSoccerdataFixturesFixtureIdMatchstatsSnapshotsSnapshotIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/fixtures/{fixtureId}/matchstats/snapshots/{snapshotId}`
                .replace(`{${'fixtureId'}}`, String(requestParameters.fixtureId))
                .replace(`{${'snapshotId'}}`, String(requestParameters.snapshotId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-match-statistics.htm\">Perform Documentation - MA2</a>
     * Returns a snapshot of the MA2 feed
     */
    async performSoccerdataFixturesFixtureIdMatchstatsSnapshotsSnapshotIdGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataFixturesFixtureIdMatchstatsSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-match-tracking.htm\">Perform Documentation - MA25</a>
     * Returns the MA25 feed
     */
    async performSoccerdataFixturesFixtureIdMatchtrackingGetRaw(requestParameters, initOverrides) {
        if (requestParameters.fixtureId === null ||
            requestParameters.fixtureId === undefined) {
            throw new runtime.RequiredError('fixtureId', 'Required parameter requestParameters.fixtureId was null or undefined when calling performSoccerdataFixturesFixtureIdMatchtrackingGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/fixtures/{fixtureId}/matchtracking`.replace(`{${'fixtureId'}}`, String(requestParameters.fixtureId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-match-tracking.htm\">Perform Documentation - MA25</a>
     * Returns the MA25 feed
     */
    async performSoccerdataFixturesFixtureIdMatchtrackingGet(requestParameters, initOverrides) {
        await this.performSoccerdataFixturesFixtureIdMatchtrackingGetRaw(requestParameters, initOverrides);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-nlg-match-preview.htm\">Perform Documentation - MA22</a>
     * Returns the MA22 feed
     */
    async performSoccerdataFixturesFixtureIdNlgmatchpreviewGetRaw(requestParameters, initOverrides) {
        if (requestParameters.fixtureId === null ||
            requestParameters.fixtureId === undefined) {
            throw new runtime.RequiredError('fixtureId', 'Required parameter requestParameters.fixtureId was null or undefined when calling performSoccerdataFixturesFixtureIdNlgmatchpreviewGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/fixtures/{fixtureId}/nlgmatchpreview`.replace(`{${'fixtureId'}}`, String(requestParameters.fixtureId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-nlg-match-preview.htm\">Perform Documentation - MA22</a>
     * Returns the MA22 feed
     */
    async performSoccerdataFixturesFixtureIdNlgmatchpreviewGet(requestParameters, initOverrides) {
        await this.performSoccerdataFixturesFixtureIdNlgmatchpreviewGetRaw(requestParameters, initOverrides);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-pass-matrix.htm\">Perform Documentation - MA4</a>
     * Returns the MA4 feed
     */
    async performSoccerdataFixturesFixtureIdPassmatrixGetRaw(requestParameters, initOverrides) {
        if (requestParameters.fixtureId === null ||
            requestParameters.fixtureId === undefined) {
            throw new runtime.RequiredError('fixtureId', 'Required parameter requestParameters.fixtureId was null or undefined when calling performSoccerdataFixturesFixtureIdPassmatrixGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/fixtures/{fixtureId}/passmatrix`.replace(`{${'fixtureId'}}`, String(requestParameters.fixtureId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-pass-matrix.htm\">Perform Documentation - MA4</a>
     * Returns the MA4 feed
     */
    async performSoccerdataFixturesFixtureIdPassmatrixGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataFixturesFixtureIdPassmatrixGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-pass-matrix.htm\">Perform Documentation - MA4</a>
     * Returns a snapshot of the MA4 feed
     */
    async performSoccerdataFixturesFixtureIdPassmatrixSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.fixtureId === null ||
            requestParameters.fixtureId === undefined) {
            throw new runtime.RequiredError('fixtureId', 'Required parameter requestParameters.fixtureId was null or undefined when calling performSoccerdataFixturesFixtureIdPassmatrixSnapshotsSnapshotIdGet.');
        }
        if (requestParameters.snapshotId === null ||
            requestParameters.snapshotId === undefined) {
            throw new runtime.RequiredError('snapshotId', 'Required parameter requestParameters.snapshotId was null or undefined when calling performSoccerdataFixturesFixtureIdPassmatrixSnapshotsSnapshotIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/fixtures/{fixtureId}/passmatrix/snapshots/{snapshotId}`
                .replace(`{${'fixtureId'}}`, String(requestParameters.fixtureId))
                .replace(`{${'snapshotId'}}`, String(requestParameters.snapshotId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-pass-matrix.htm\">Perform Documentation - MA4</a>
     * Returns a snapshot of the MA4 feed
     */
    async performSoccerdataFixturesFixtureIdPassmatrixSnapshotsSnapshotIdGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataFixturesFixtureIdPassmatrixSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-possession.htm\">Perform Documentation - MA5</a>
     * Returns a snapshot of the MA5 feed
     */
    async performSoccerdataFixturesFixtureIdPossessionGetRaw(requestParameters, initOverrides) {
        if (requestParameters.fixtureId === null ||
            requestParameters.fixtureId === undefined) {
            throw new runtime.RequiredError('fixtureId', 'Required parameter requestParameters.fixtureId was null or undefined when calling performSoccerdataFixturesFixtureIdPossessionGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/fixtures/{fixtureId}/possession`.replace(`{${'fixtureId'}}`, String(requestParameters.fixtureId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-possession.htm\">Perform Documentation - MA5</a>
     * Returns a snapshot of the MA5 feed
     */
    async performSoccerdataFixturesFixtureIdPossessionGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataFixturesFixtureIdPossessionGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-possession.htm\">Perform Documentation - MA5</a>
     * Returns a snapshot of the MA5 feed
     */
    async performSoccerdataFixturesFixtureIdPossessionSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.fixtureId === null ||
            requestParameters.fixtureId === undefined) {
            throw new runtime.RequiredError('fixtureId', 'Required parameter requestParameters.fixtureId was null or undefined when calling performSoccerdataFixturesFixtureIdPossessionSnapshotsSnapshotIdGet.');
        }
        if (requestParameters.snapshotId === null ||
            requestParameters.snapshotId === undefined) {
            throw new runtime.RequiredError('snapshotId', 'Required parameter requestParameters.snapshotId was null or undefined when calling performSoccerdataFixturesFixtureIdPossessionSnapshotsSnapshotIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/fixtures/{fixtureId}/possession/snapshots/{snapshotId}`
                .replace(`{${'fixtureId'}}`, String(requestParameters.fixtureId))
                .replace(`{${'snapshotId'}}`, String(requestParameters.snapshotId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-possession.htm\">Perform Documentation - MA5</a>
     * Returns a snapshot of the MA5 feed
     */
    async performSoccerdataFixturesFixtureIdPossessionSnapshotsSnapshotIdGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataFixturesFixtureIdPossessionSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-possession-events.htm\">Perform Documentation - MA13</a>
     * Returns the MA13 feed
     */
    async performSoccerdataFixturesFixtureIdPossessioneventGetRaw(requestParameters, initOverrides) {
        if (requestParameters.fixtureId === null ||
            requestParameters.fixtureId === undefined) {
            throw new runtime.RequiredError('fixtureId', 'Required parameter requestParameters.fixtureId was null or undefined when calling performSoccerdataFixturesFixtureIdPossessioneventGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/fixtures/{fixtureId}/possessionevent`.replace(`{${'fixtureId'}}`, String(requestParameters.fixtureId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-possession-events.htm\">Perform Documentation - MA13</a>
     * Returns the MA13 feed
     */
    async performSoccerdataFixturesFixtureIdPossessioneventGet(requestParameters, initOverrides) {
        await this.performSoccerdataFixturesFixtureIdPossessioneventGetRaw(requestParameters, initOverrides);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-fixtures-and-results.htm\">Perform Documentation - MA1</a>
     * Returns a snapshot of the MA1 feed
     */
    async performSoccerdataFixturesFixtureIdSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.fixtureId === null ||
            requestParameters.fixtureId === undefined) {
            throw new runtime.RequiredError('fixtureId', 'Required parameter requestParameters.fixtureId was null or undefined when calling performSoccerdataFixturesFixtureIdSnapshotsSnapshotIdGet.');
        }
        if (requestParameters.snapshotId === null ||
            requestParameters.snapshotId === undefined) {
            throw new runtime.RequiredError('snapshotId', 'Required parameter requestParameters.snapshotId was null or undefined when calling performSoccerdataFixturesFixtureIdSnapshotsSnapshotIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/fixtures/{fixtureId}/snapshots/{snapshotId}`
                .replace(`{${'fixtureId'}}`, String(requestParameters.fixtureId))
                .replace(`{${'snapshotId'}}`, String(requestParameters.snapshotId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-fixtures-and-results.htm\">Perform Documentation - MA1</a>
     * Returns a snapshot of the MA1 feed
     */
    async performSoccerdataFixturesFixtureIdSnapshotsSnapshotIdGet(requestParameters, initOverrides) {
        const response = await this.performSoccerdataFixturesFixtureIdSnapshotsSnapshotIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-suspensions.htm\">Perform Documentation - PE8</a>
     * Returns the PE8 feed
     */
    async performSoccerdataFixturesFixtureIdSuspensionsGetRaw(requestParameters, initOverrides) {
        if (requestParameters.fixtureId === null ||
            requestParameters.fixtureId === undefined) {
            throw new runtime.RequiredError('fixtureId', 'Required parameter requestParameters.fixtureId was null or undefined when calling performSoccerdataFixturesFixtureIdSuspensionsGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/fixtures/{fixtureId}/suspensions`.replace(`{${'fixtureId'}}`, String(requestParameters.fixtureId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-suspensions.htm\">Perform Documentation - PE8</a>
     * Returns the PE8 feed
     */
    async performSoccerdataFixturesFixtureIdSuspensionsGet(requestParameters, initOverrides) {
        await this.performSoccerdataFixturesFixtureIdSuspensionsGetRaw(requestParameters, initOverrides);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-fixtures-and-results.htm\">Perform Documentation - MA1</a>
     * Returns the MA1 feed [NO SNAPSHOT LAYER]
     */
    async performSoccerdataFixturesGetRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.competitionId !== undefined) {
            queryParameters['competitionId'] = requestParameters.competitionId;
        }
        if (requestParameters.contestantId !== undefined) {
            queryParameters['contestantId'] = requestParameters.contestantId;
        }
        if (requestParameters.contestant2Id !== undefined) {
            queryParameters['contestant2Id'] = requestParameters.contestant2Id;
        }
        if (requestParameters.contestantpos !== undefined) {
            queryParameters['contestantpos'] = requestParameters.contestantpos;
        }
        if (requestParameters.matchTimeRangeStart !== undefined) {
            queryParameters['matchTimeRangeStart'] =
                requestParameters.matchTimeRangeStart;
        }
        if (requestParameters.matchTimeRangeEnd !== undefined) {
            queryParameters['matchTimeRangeEnd'] = requestParameters.matchTimeRangeEnd;
        }
        if (requestParameters.stageId !== undefined) {
            queryParameters['stageId'] = requestParameters.stageId;
        }
        if (requestParameters.seriesId !== undefined) {
            queryParameters['seriesId'] = requestParameters.seriesId;
        }
        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }
        if (requestParameters.tournamentCalendarId !== undefined) {
            queryParameters['tournamentCalendarId'] =
                requestParameters.tournamentCalendarId;
        }
        if (requestParameters.week !== undefined) {
            queryParameters['week'] = requestParameters.week;
        }
        if (requestParameters.lineups !== undefined) {
            queryParameters['lineups'] = requestParameters.lineups;
        }
        if (requestParameters.live !== undefined) {
            queryParameters['live'] = requestParameters.live;
        }
        if (requestParameters.personId !== undefined) {
            queryParameters['personId'] = requestParameters.personId;
        }
        if (requestParameters.personType !== undefined) {
            queryParameters['personType'] = requestParameters.personType;
        }
        if (requestParameters.sortMatchTimeDesc !== undefined) {
            queryParameters['sortMatchTimeDesc'] = requestParameters.sortMatchTimeDesc;
        }
        if (requestParameters.deltaTime !== undefined) {
            queryParameters['deltaTime'] = requestParameters.deltaTime;
        }
        if (requestParameters.coverageLevel !== undefined) {
            queryParameters['coverageLevel'] = requestParameters.coverageLevel;
        }
        if (requestParameters.optaBetting !== undefined) {
            queryParameters['optaBetting'] = requestParameters.optaBetting;
        }
        if (requestParameters.pageNumber !== undefined) {
            queryParameters['pageNumber'] = requestParameters.pageNumber;
        }
        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken('OAuth2', []);
        }
        const response = await this.request({
            path: `/perform/soccerdata/fixtures`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * More details in: <a href=\"https://documentation.statsperform.com/docs/data/reference/soccer/opta-sdapi-soccer-api-fixtures-and-results.htm\">Perform Documentation - MA1</a>
     * Returns the MA1 feed [NO SNAPSHOT LAYER]
     */
    async performSoccerdataFixturesGet(requestParameters = {}, initOverrides) {
        const response = await this.performSoccerdataFixturesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
//# sourceMappingURL=FixturesApi.js.map